import styled from 'styled-components';
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import { layout, colors } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import { Hideable } from '@prisjakt/ui/hideable';

export const ListHeader = styled.div`
  background: ${colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.lines.secondary};
  display: flex;
  align-items: center;
  color: inherit;
  font-size: 1rem;

  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */
  box-sizing: border-box;
  width: 100%;

  &:hover,
  &.focus-visible {
    background-color: ${props => props.theme.bg.secondary};
  }
`;

export const MainArea = styled(Clickable)`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1 0 auto;
  min-height: 64px;
  padding: ${layout.spacing.xSmall} ${layout.spacing.small};
  padding-right: 0;
`;

export const LeftArrowArea = styled(Hideable).attrs({ renderWhenHidden: true })`
  /* Increase specifity to override Hideable flex property */
  && {
    align-items: center;
    flex: 0 0 auto;
    justify-content: center;
    width: 34px;
    height: 34px;
  }
`;

export const LeftArrow = styled(ChevronLeftIcon).attrs({ size: 20 })`
  margin-right: ${layout.spacing.xSmall};
  path {
    fill: currentColor;
  }
`;

export const HeaderTitle = styled.div`
  flex: 1 1 auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 900;
`;

export const ExtraContentArea = styled.div`
  align-items: center;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  padding: ${layout.spacing.xSmall} ${layout.spacing.small};
  padding-left: 0;
  /* Reserve space for an extra option */
  width: 34px;
  height: 34px;
`;
